import { Button, Modal, Empty, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { PlusOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import Add from './Add'
import ServiceCard from './ServiceCard'
import { useService } from './ServiceStore'
import Edit from './Edit'

const { Text } = Typography

const Services = () => {
    let [addopen, setAddOpen] = useState(false)
    let [ed, setEd] = useState(null)
    let [edopen, setEdOpen] = useState(false)
    let { services, getSerices, deleteService } = useService()
    useEffect(() => {
        getSerices()
    }, [])

    const handleDelete = (service) => {
        Modal.confirm({
            title: "Xizmatni o'chirmoqchimisiz?",
            icon: <ExclamationCircleFilled />,
            content: `"${service.name}" xizmati butunlay o'chiriladi. Bu amalni qaytarib bo'lmaydi.`,
            okText: "O'chirish",
            okButtonProps: { danger: true },
            cancelText: 'Bekor qilish',
            onOk: () => deleteService(service.id),
        })
    }
    return (
        <>
            <Modal title="Xizmat joylash" width={1000} open={addopen} onCancel={() => setAddOpen(false)} footer={null}>
                <Add />
            </Modal>
            <Modal title="Xizmat tahrirlash" width={1000} open={edopen} onCancel={() => setEdOpen(false)} footer={null}>
                <Edit service={ed} />
            </Modal>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>Xizmatlar</h2>
                <Button type='primary' icon={<PlusOutlined />} onClick={() => setAddOpen(true)}>Yangi xizmat qo'shish</Button>
            </div>
            {services.length ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
                    {services.map(service => (
                        <ServiceCard
                            key={service.id}
                            service={service}
                            onEdit={(s) => {
                                setEd(s)
                                setEdOpen(true)
                            }}
                            onDelete={handleDelete}
                        />
                    ))}
                </div>
            ) : (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<Text type="secondary">Hali xizmat qo'shilmagan</Text>}
                    style={{ marginTop: 60 }}
                />
            )}
        </>
    )
}

export default Services